module.exports = __webpack_public_path__ + "img/tryk_og_glad_malesider_1.aca2d79c.jpg";